<app-reference-detail-list *ngIf="constraint" [constraint]="constraint"></app-reference-detail-list>
